import {pluralize, React, Suspense, useEffect, useIntersectionObserver, useLayoutEffect} from '@api'
import {Typography} from '@material-ui/core'
import {BuilderCardField, useBuilderCardStore} from '@modules'
import FlipMove from 'react-flip-move'
import * as css from './BuilderCard.css'
import {CheckboxInput} from 'centric-ui-components'
import {observer} from 'mobx-react-lite'

export const BuilderCardFields = observer<{}>(
  function BuilderCardFields({}) {
    const store = useBuilderCardStore(),
      {
        data, visibleCardFields, groupsVisibleFields, perspectiveSectionConfig,
        es, catalog: {cv: {groupedVisibleCardFields}}, stores: {userSettings: {dev}}
      } = store, virtualizedCatalog = dev?.virtualizedCatalog

    const [{isIntersecting}, observerRef] = useIntersectionObserver(),
      everVisible = store.fieldsEverVisible || isIntersecting || virtualizedCatalog
    useLayoutEffect(() => { if (everVisible) store.fieldsEverVisible = everVisible}, [everVisible])
    useEffect(() => {
      store.fieldsAreOnScreen = isIntersecting || virtualizedCatalog
    }, [isIntersecting])
    //console.log({everVisible, isIntersecting})

    const childrenCount = (perspectiveSectionConfig?.viewOptions?.field ? 1 : 0) + (visibleCardFields?.length ?? 0) + groupsVisibleFields.length

    // console.log({data, store, type: store.props.type, childrenCount, visibleCardFields})

    return (
      childrenCount === 0 ? null :
      <div
        ref={virtualizedCatalog ? undefined : observerRef}
        className={css.fieldContainerWrapper}
        data-ever-visible={everVisible}>
        <Suspense fallback={null}>
          {everVisible && //// duration={100} enterAnimation='none' appearAnimation='fade' leaveAnimation='none' disableAllAnimations={store.isCardFieldDragging}> // Far too slow as it measures
		   <div className={css.fieldContainer}>
             {perspectiveSectionConfig?.viewOptions?.field && <BuilderCardField f={{section: perspectiveSectionConfig.id, field: `${perspectiveSectionConfig.path}.${perspectiveSectionConfig.viewOptions.field}`, label: `${pluralize(perspectiveSectionConfig.label, 1)}`}}/>}
             {visibleCardFields?.map((f) => <BuilderCardField key={f.field} f={f}/>)}
             {/*{_.keys(sectionGroupedFields).map((section, i) => {*/}
             {/*  const keys = catalog.sectionValues.get(section)*/}
             {/*  console.log(keys)*/}
             {/*  return <div>*/}
             {/*    {section}*/}
             {/*    {(keys ?? []).map(k => <span>{k.key}</span>)}*/}
             {/*  </div>})}*/}
             {
               groupsVisibleFields.length > 0 ? groupsVisibleFields.map((group) =>
                 <div key={`${group}`} data-type='region-checkbox-group' className={css.cardField}>
                   <Typography variant={'body1'} data-type='title' className={css.title}>{group}</Typography>
                   <div className={css.fieldGroup}>
                     {groupedVisibleCardFields[group].map(({field, group, def}) => {
                       const value = es.readField(data, field, group?.field)
                       return (
                         <CheckboxInput checked={Boolean(value?.val)} key={field} label={def?.displayName.singular} disabled name={field}/>
                       )
                     })}
                   </div>
                 </div>) : null
             }
		   </div>}
        </Suspense>
      </div>
    )
  })



// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/BuilderCard/BuilderCardFields.tsx